export default __webpack_public_path__ + "static/media/langchain.626a1bf3.svg";